import React, { useState, useEffect } from 'react';
import './ScrollToTop.scss';
import SvgIcons from '../../services/SvgIcons';

const ScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            // Calcul du seuil de 35% de la hauteur de la fenêtre
            const scrollThreshold = window.innerHeight * 0.35;

            if (window.pageYOffset > scrollThreshold) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        // Écouter l'événement scroll
        window.addEventListener('scroll', toggleVisibility);
        // Vérification initiale
        toggleVisibility();
        
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <>
            {/* Bouton mobile fixe */}
            <button
                className={`scroll-to-top-mobile ${isVisible ? 'visible' : ''}`}
                onClick={scrollToTop}
                aria-label="Retour en haut de la page"
            >
                <SvgIcons
                    name={'chevron_back'}
                    width={40}
                    height={40}
                    color={'#AF968C'}
                    transform={'rotate(90deg)'}
                />
            </button>

            {/* Bandeau statique */}
            <div className='scroll-to-top-banner visible'>
                <button
                    onClick={scrollToTop}
                    aria-label="Retour en haut de la page"
                >
                    <SvgIcons
                        name={'chevron_back'}
                        width={40}
                        height={40}
                        color={'#7B463F'}
                        transform={'rotate(90deg)'}
						strokeWidth={30}
                    />
                    <span>Retour en haut</span>
                </button>
            </div>
        </>
    );
};

export default ScrollToTop;